import "./intro.scss"
import { init } from "ityped";
import { useEffect, useRef } from "react";

export default function Intro() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["Science Major", "Programmer", "Enthusiast"],
    });
  }, []);
  return (
    <div className="intro" id= "intro">
        <div className="left">
          <div className="imgContainer">
              <img src="assests/pfp2.png" alt=""/>
             </div>
        </div>
        <div className="right">
          <div className="wrapper">
            <h2> Hi There, I'm</h2>
            <h1>Derek Pruski</h1>
            <h3>Computer <span ref = {textRef}> </span></h3>
          </div>
          <a href="#portfolio">
            <img src="assests/down.png" alt="" />
          </a>
        </div>
    </div>
  );
}
